import "./Footer.scss";

export function Footer({ children })
{
    return (<div styleName="footer">
        {children}
    </div>);
}